
<template>
  <div class="modal-overlay" @click="$emit('close-modal')">
    <div class="modal" @click.stop>
        <a-row :gutter="25">
          <a-col>
            <BasicFormWrapper>
            <div class="setting-card-title">
              <sdHeading as="h5" style="font-weight: 500">
              <h3>QBO Client Connection</h3><hr />
            <a-form
              name="contact"
              :rules="rules"
              :model="formState"
              @submit="handleOk"
              :layout="formState.layout"
            >
            <a-row>
            <a-col>
            <a-form-item name="client" label="Main Client:">
             <a-input
              v-model:value="formState.client"
              placeholder="Add Client Name"
              />
            </a-form-item> 
            </a-col>
            <!--<a-col>
            <a-form-item name="subclient" label="Sub-Client:">
             <a-input
              v-model:value="formState.subclient"
              placeholder="Add Sub Client Name"
              />
            </a-form-item> 
            </a-col>-->
            
            </a-row>
            <!--<a-row>
            <a-col>
            <a-form-item name="currency" label="Currency:">
             <a-input
              v-model:value="formState.currency"
              placeholder="Add Currency"
              />
            </a-form-item> 
            </a-col>
            </a-row>
            <a-row>
            <a-col>
            <a-form-item name="scheme" label="VAT Scheme:">
             <a-input
              v-model:value="formState.scheme"
              placeholder="Add VAT Scheme"
              />
            </a-form-item> 
            </a-col>
            <a-col>
            <a-form-item name="frequency" label="VAT Frequency:">
             <a-input
              v-model:value="formState.frequency"
              placeholder="Add VAT Frequency"
              />
            </a-form-item> 
            </a-col>
            </a-row>-->
            <a-row>
            <a-col>
            <a-form-item name="start" label="Sync Startdate:">
              <a-date-picker
                  style="padding-left: 0px !important"
                  @change="DateSelect1"
                  :defaultValue="selectrange1"
                  placeholder="Input StartDate"
                /> 
            </a-form-item> 
            </a-col>
            <a-col>
            <a-form-item name="end" label="Sync Enddate:">
              <a-date-picker
                  @change="DateSelect2"
                  :defaultValue="selectrange2"
                  placeholder="Input EndDate"
                />
            </a-form-item> 
            </a-col>
            </a-row>
            <a-row>
            <a-col>
                <a-button 
                style="margin: 0 20% !important"
                htmlType="submit"
                size="default"
                type="primary"
                key="submit"
              >
                Submit
              </a-button>
              </a-col>
              </a-row>
            </a-form>
            </sdHeading>
            </div>
          </BasicFormWrapper>
          </a-col>
         
          </a-row>
    </div>
    <div class="close" @click="$emit('close-modal')">
      <sdFeatherIcons type="x-circle" size="25" style="color:#fff !important;" />
    </div>
  </div>

</template>
<script>
import { Main, TableWrapper } from "/src/view/styled";
import { computed, ref, defineComponent, onMounted ,reactive, toRefs} from "vue";
import { useRoute, useRouter } from "vue-router";
import { message, Notification } from "ant-design-vue";
import { useStore } from "vuex";
import { UserTableStyleWrapper, Action, ProductCard } from "/src/view/dashboard/style";
import * as FontAwesomeIcon from "@fortawesome/free-solid-svg-icons";
  export default defineComponent({
  name: "ModalQbo",
  props: {
  message: {
    type: String,
    required: false,
  },
  },
  components: {
    Main,
    TableWrapper,
    UserTableStyleWrapper,
    ProductCard,
    FontAwesomeIcon,
    Action,
  },
  setup(props) {
  const { message } = toRefs(props);
    let orgdata = ref("");
    let count = ref("");
    let client_name = ref("");
    const param = useRoute();
    let showModal= ref(false);
    const router = useRouter();
    const { state, dispatch } = useStore();
    var selectrange = ref(null);
    var selectrange1 = ref(null);
    var selectrange2 = ref(null);
    const file1 = ref(null);
    var loading = ref(true);
    onMounted(() => {
    });
    const formState = reactive({
      client: "",
      subclient: "",
      currency: "",
      scheme: "",
      frequency: "",
      layout: "vertical",
      
    });
    const handleOk = (values) => {
      qboadd();
    };
   const DateSelect1 = (date, dateString) => {
      selectrange1.value = dateString;
      validateDateRange();
    };
    const DateSelect2 = (date, dateString) => {
      selectrange2.value = dateString;
      validateDateRange();
    };
    const validateDateRange = () => {
    if (selectrange1.value && selectrange2.value) {
      const startDate = new Date(selectrange1.value);
      const endDate = new Date(selectrange2.value);
      const oneYearLater = new Date(startDate);
      oneYearLater.setFullYear(startDate.getFullYear() + 1);

      if (endDate > oneYearLater) {
        alert("The selected date range exceeds one year. Please select a valid range.");
        // Reset the invalid range (optional)
        selectrange2.value = null;
      }
    }
  };
    const qboadd = () => {
      let startdate =selectrange1.value.toString();
      let enddate =selectrange2.value.toString();
      let api_data = [];
      api_data['client'] = formState.client;
      api_data['subclient'] = formState.subclient;
      api_data['currency'] = formState.currency;
      api_data['scheme'] = formState.scheme;
      api_data['frequency'] = formState.frequency;
      api_data['startdate'] = startdate;
      api_data['enddate'] = enddate;
      dispatch("addQboClient", api_data).then(
        (response) => {
          Notification["success"]({
              message: "QBO client Added",
          });
          //location.reload(true);
        },
        (error) => {
        Notification["error"]({
              message: "Error!",
              description: error.data.msg
            });

        });
    };

    return {
      orgdata,
      client_name,
      showModal,
      count,
      qboadd,
      handleOk,
      formState,
      loading,
      file1,
      selectrange1,
      selectrange2,
      DateSelect1,
      DateSelect2,
      validateDateRange,
    };
  },
});

</script>

<style scoped>

.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}

.modal {
  text-align: center;
  background-color: white;
  height: 350px;
  width: 480px;
  margin-top: 1%;
  padding: 40px 20px 0px 20px;
  border-radius: 20px;
}
.close {
  margin: 10% 0 0 8px;
  cursor: pointer;
}

.close-img {
  width: 25px;
}

.check {
  width: 150px;
}

h6 {
  font-weight: 500;
  font-size: 28px;
  margin: 20px 0;
}

p {
  font-size: 16px;
  margin: 20px 0;
}

button {
  background-color: #5F63F2;
  width: 150px;
  height: 40px;
  color: white;
  font-size: 14px;
  border-radius: 16px;
  margin-top: 50px;
}
</style>